const WORKSPACE_ONBOARDING_KEY = 'workspace-hierarchy-onboarding:v1'
const inMemoryCompletedOnboarding = new Set<string>()

function getWorkspaceOnboardingKey(userEmail?: string | null): string {
  if (!userEmail) {
    return WORKSPACE_ONBOARDING_KEY
  }

  return `${WORKSPACE_ONBOARDING_KEY}:${userEmail.trim().toLowerCase()}`
}

export function hasCompletedWorkspaceOnboarding(userEmail?: string | null): boolean {
  if (typeof window === 'undefined') {
    return true
  }

  const storageKey = getWorkspaceOnboardingKey(userEmail)

  if (inMemoryCompletedOnboarding.has(storageKey)) {
    return true
  }

  try {
    return localStorage.getItem(storageKey) === 'completed'
  } catch {
    return true
  }
}

export function completeWorkspaceOnboarding(userEmail?: string | null): void {
  if (typeof window === 'undefined') {
    return
  }

  const storageKey = getWorkspaceOnboardingKey(userEmail)
  inMemoryCompletedOnboarding.add(storageKey)

  try {
    localStorage.setItem(storageKey, 'completed')
  } catch {
    // Fall back to in-memory state so the current session can continue.
  }
}

export function resetWorkspaceOnboarding(userEmail?: string | null): void {
  if (typeof window === 'undefined') {
    return
  }

  const storageKey = getWorkspaceOnboardingKey(userEmail)
  inMemoryCompletedOnboarding.delete(storageKey)

  try {
    localStorage.removeItem(storageKey)
  } catch {
    // Ignore storage failures in tests and private browsing.
  }
}
